import { Directive, HostListener, ElementRef, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputMask]'
})
export class InputMaskDirective {

  @Input('appInputMask') mask: string = ''; // Exemple: 'AAAAAA-AAAAAA'

  private updating = false;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private control: NgControl // récupère le FormControl si lié
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (this.updating) return;

    let inputValue = this.el.nativeElement.value;

    // Retire tous les caractères non alphanumériques
    const rawValue = inputValue.replace(/[^A-Za-z0-9]/g, '');

    // Applique le masque
    let maskedValue = '';
    let valueIndex = 0;

    for (let i = 0; i < this.mask.length && valueIndex < rawValue.length; i++) {
      if (this.mask[i] === 'A') {
        maskedValue += rawValue[valueIndex];
        valueIndex++;
      } else {
        maskedValue += this.mask[i]; // séparateur fixe
      }
    }

    maskedValue = maskedValue.toUpperCase(); // optionnel : majuscules

    // ⚡ Mise à jour “silencieuse” pour éviter de déclencher valueChanges multiples
    this.updating = true;
    this.el.nativeElement.value = maskedValue;

    if (this.control?.control) {
      // met à jour le FormControl mais **sans émettre d'événement**
      this.control.control.setValue(maskedValue, { emitEvent: false });
    }

    this.updating = false;
  }
}